// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"88918a3d","631":"6d8e80fb","804":"617dbde8","952":"1d9a4474"}[chunkId] + ".chunk.css";
};